import api from "./api";

const notificationService = {
  getNotifications: async () => {
    const response = await api.get("/notifications/");
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get("/notifications/unread_count/");
    return response.data;
  },

  markAsRead: async (id) => {
    const response = await api.post(`/notifications/${id}/mark_as_read/`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await api.post("/notifications/mark_all_as_read/");
    return response.data;
  },

  clearAll: async () => {
    const response = await api.post("/notifications/clear_all/");
    return response.data;
  },

  pushSubscribe: async (subscription) => {
    const response = await api.post("/notifications/push-subscribe/", subscription);
    return response.data;
  },

  pushUnsubscribe: async (endpoint) => {
    const response = await api.post("/notifications/push-unsubscribe/", { endpoint });
    return response.data;
  },
};

export default notificationService;
